<template>
  <div>
    <div class="name-list-wrapper">
      <p class="title">选择体检人员</p>
      <van-radio-group v-model="radio">
        <div class="name-card">
          <van-cell clickable class="van-cell--borderless" @click="radio = '1'">
            <template #default>
              <van-radio name="1" />
              <div class="name-info">
                <span class="name-info-title">张三</span>
                <p class="name-info-idcard">身份证号：111111111111111</p>
              </div>
            </template>
          </van-cell>
          <van-icon name="edit" class="edit-icon" />
        </div>
        <div class="name-card">
          <van-cell clickable class="van-cell--borderless" @click="radio = '2'">
            <template #default>
              <van-radio name="2" />
              <div class="name-info">
                <span class="name-info-title">李四</span>
                <p class="name-info-idcard">身份证号：111111111111111</p>
              </div>
            </template>
          </van-cell>
          <van-icon name="edit" class="edit-icon" />
        </div>
      </van-radio-group>
    </div>

    <div class="name-list-footer fixed-footer">
      <van-button size="large" round @click="submit()">立即预约</van-button>
    </div>
  </div>
</template>

<style lang="less" scoped>
.name-list-wrapper {
  box-sizing: border-box;
  height: 100%;
  padding: 12px 12px 100px;
  .title {
    margin: 0;
    padding: 32px 16px 16px;
    color: rgba(69, 90, 100, 0.6);
    font-weight: normal;
    font-size: 14px;
    line-height: 16px;
  }
  .name-card {
    padding: 12px;
    background-color: #fff;
    border-radius: 8px;
    margin-bottom: 12px;
    display: flex;
    position: relative;
    .van-cell {
      padding: 8px;
      padding-right: 44px;

      .van-cell__value--alone {
        display: flex;
      }
    }
    .van-cell--borderless::after {
      display: none;
    }
    .name-info {
      margin-left: 12px;
      .name-info-title {
        display: block;
        font-size: 16px;
        margin-bottom: 4px;
      }
      .name-info-idcard {
        color: #323233;
        font-size: 13px;
        line-height: 18px;
      }
    }
    .edit-icon {
      position: absolute;
      top: 50%;
      right: 16px;
      color: #969799;
      font-size: 20px;
      -webkit-transform: translate(0, -50%);
      transform: translate(0, -50%);
      border:none;
    }
  }
}
.name-list-footer {
  background: #ffffff;
  padding: 5px 0;
  width: 100%;
  text-align: center;
  .van-button {
    width: 90%;
    height: 40px;
    line-height: 40px;
    background-image: linear-gradient(to right, #4dc9ef, var(--color-main));
    color: #ffffff;
  }
}
</style>

<script>
export default {
  data() {
    return {
      radio: "1"
    };
  },
  methods: {
      submit(){
          this.$router.push("/submitOrder");
      }
  },
};
</script>